import React from "react";

import { THEMES } from "./components/common/common.constants";

const Theme = React.createContext(THEMES.DARK);

export default Theme;
